import React from 'react'

import { reverse } from 'named-urls'

import { Table, TableBody, TableRow, TableCell, Box } from '@material-ui/core'

import { GenerateSkeleton } from 'components/Table'
import { routes } from 'routes'
import { LogIconButton } from 'components/Logs'
import constants from './../../../../../../constants'
import helpers from 'helpers'

const SettingsInvoiceTable = ({ isLoading, settings }) => {
  return isLoading ? (
    <Table>
      <TableBody>
        <GenerateSkeleton rows={7} cols={2} />
      </TableBody>
    </Table>
  ) : (
    <Table>
      <TableBody>
        <TableRow hover>
          <TableCell width="60%">
            Dias para definir uma assinatura como inadimplente por falta de
            pagamento
          </TableCell>
          <TableCell>
            <Box
              display="flex"
              alignItems="center"
              justifyContent="space-between"
            >
              {settings.contractOverdue && settings.contractOverdue.value}
              <LogIconButton
                to={reverse(routes.settings.logs, {
                  settingId: constants.settings.CONTRACT_OVERDUE,
                })}
              />
            </Box>
          </TableCell>
        </TableRow>
        <TableRow hover>
          <TableCell>
            Dias para cancelar uma assinatura após inadimplência
          </TableCell>
          <TableCell>
            <Box
              display="flex"
              alignItems="center"
              justifyContent="space-between"
            >
              {settings.contractCancelOverdue &&
                settings.contractCancelOverdue.value}
              <LogIconButton
                to={reverse(routes.settings.logs, {
                  settingId: constants.settings.CONTRACT_CANCEL_OVERDUE,
                })}
              />
            </Box>
          </TableCell>
        </TableRow>
        <TableRow hover>
          <TableCell>
            Dias para cancelar uma assinatura por falta de primeiro pagamento
          </TableCell>
          <TableCell>
            <Box
              display="flex"
              alignItems="center"
              justifyContent="space-between"
            >
              {settings.contractCancelPending &&
                settings.contractCancelPending.value}
              <LogIconButton
                to={reverse(routes.settings.logs, {
                  settingId: constants.settings.CONTRACT_CANCEL_PENDING,
                })}
              />
            </Box>
          </TableCell>
        </TableRow>
        <TableRow hover>
          <TableCell>
            Dias para geração da fatura antes do vencimento da assinatura
          </TableCell>
          <TableCell>
            <Box
              display="flex"
              alignItems="center"
              justifyContent="space-between"
            >
              {settings.invoiceInterval && settings.invoiceInterval.value}
              <LogIconButton
                to={reverse(routes.settings.logs, {
                  settingId: constants.settings.INVOICE_INTERVAL,
                })}
              />
            </Box>
          </TableCell>
        </TableRow>
        <TableRow hover>
          <TableCell>
            Número de parcelas permitido na fatura quando paga com cartão de
            crédito
          </TableCell>
          <TableCell>
            <Box
              display="flex"
              alignItems="center"
              justifyContent="space-between"
            >
              {settings.paymentMaxSplit && settings.paymentMaxSplit.value}
              <LogIconButton
                to={reverse(routes.settings.logs, {
                  settingId: constants.settings.PAYMENT_MAX_SPLIT,
                })}
              />
            </Box>
          </TableCell>
        </TableRow>
        <TableRow hover>
          <TableCell>
            Dias para o vencimento da primeira fatura a partir da contratação
          </TableCell>
          <TableCell>
            <Box
              display="flex"
              alignItems="center"
              justifyContent="space-between"
            >
              {settings.paymentDaysToGenerate &&
                settings.paymentDaysToGenerate.value}
              <LogIconButton
                to={reverse(routes.settings.logs, {
                  settingId: constants.settings.PAYMENT_DAYS_TO_GENERATE,
                })}
              />
            </Box>
          </TableCell>
        </TableRow>
        <TableRow hover>
          <TableCell>Gerar fatura mesmo que inadimplente</TableCell>
          <TableCell>
            <Box
              display="flex"
              alignItems="center"
              justifyContent="space-between"
            >
              {settings.invoicesGenerationOnOverdue &&
                helpers.settings.formatBooleanSetting(
                  settings.invoicesGenerationOnOverdue.value,
                )}
              <LogIconButton
                to={reverse(routes.settings.logs, {
                  settingId: constants.settings.INVOICES_GENERATION_ON_OVERDUE,
                })}
              />
            </Box>
          </TableCell>
        </TableRow>
        <TableRow hover>
          <TableCell>Primeira fatura proporcional</TableCell>
          <TableCell>
            <Box
              display="flex"
              alignItems="center"
              justifyContent="space-between"
            >
              {settings.generateFirstInvoiceProportional &&
                helpers.settings.formatBooleanSetting(
                  settings.generateFirstInvoiceProportional.value,
                )}
              <LogIconButton
                to={reverse(routes.settings.logs, {
                  settingId:
                    constants.settings.GENERATE_FIRST_INVOICE_PROPORTIONAL,
                })}
              />
            </Box>
          </TableCell>
        </TableRow>
        <TableRow hover>
          <TableCell>Proporcional em inadimplência</TableCell>
          <TableCell>
            <Box
              display="flex"
              alignItems="center"
              justifyContent="space-between"
            >
              {settings.generateProportionalOnOverdue &&
                helpers.settings.formatBooleanSetting(
                  settings.generateProportionalOnOverdue.value,
                )}
              <LogIconButton
                to={reverse(routes.settings.logs, {
                  settingId:
                    constants.settings.GENERATE_PROPORTIONAL_ON_OVERDUE,
                })}
              />
            </Box>
          </TableCell>
        </TableRow>
        <TableRow hover>
          <TableCell>Proporcional em suspensão</TableCell>
          <TableCell>
            <Box
              display="flex"
              alignItems="center"
              justifyContent="space-between"
            >
              {settings.generateProportionalOnPause &&
                helpers.settings.formatBooleanSetting(
                  settings.generateProportionalOnPause.value,
                )}
              <LogIconButton
                to={reverse(routes.settings.logs, {
                  settingId: constants.settings.GENERATE_PROPORTIONAL_ON_PAUSE,
                })}
              />
            </Box>
          </TableCell>
        </TableRow>
        <TableRow hover>
          <TableCell>Proporcional em mudança de dia de faturamento</TableCell>
          <TableCell>
            <Box
              display="flex"
              alignItems="center"
              justifyContent="space-between"
            >
              {settings.generateProportionalOnDayExpirationChanges &&
                helpers.settings.formatBooleanSetting(
                  settings.generateProportionalOnDayExpirationChanges.value,
                )}
              <LogIconButton
                to={reverse(routes.settings.logs, {
                  settingId:
                    constants.settings
                      .GENERATE_PROPORTIONAL_ON_DAY_EXPIRATION_CHANGES,
                })}
              />
            </Box>
          </TableCell>
        </TableRow>
        <TableRow hover>
          <TableCell>
            Fatura proporcional em inativação e cancelamento
          </TableCell>
          <TableCell>
            <Box
              display="flex"
              alignItems="center"
              justifyContent="space-between"
            >
              {settings.generateInvoiceWhenInactivated &&
                helpers.settings.formatBooleanSetting(
                  settings.generateInvoiceWhenInactivated.value,
                )}
              <LogIconButton
                to={reverse(routes.settings.logs, {
                  settingId:
                    constants.settings.GENERATE_INVOICE_WHEN_INACTIVATED,
                })}
              />
            </Box>
          </TableCell>
        </TableRow>
        <TableRow hover>
          <TableCell>Proporcional em upgrade</TableCell>
          <TableCell>
            <Box
              display="flex"
              alignItems="center"
              justifyContent="space-between"
            >
              {settings.generateProportionalOnUpgrade &&
                helpers.settings.formatBooleanSetting(
                  settings.generateProportionalOnUpgrade.value,
                )}
              <LogIconButton
                to={reverse(routes.settings.logs, {
                  settingId:
                    constants.settings.GENERATE_PROPORTIONAL_ON_UPGRADE,
                })}
              />
            </Box>
          </TableCell>
        </TableRow>
        <TableRow hover>
          <TableCell>Proporcional em downgrade</TableCell>
          <TableCell>
            <Box
              display="flex"
              alignItems="center"
              justifyContent="space-between"
            >
              {settings.generateProportionalOnDowngrade &&
                helpers.settings.formatBooleanSetting(
                  settings.generateProportionalOnDowngrade.value,
                )}
              <LogIconButton
                to={reverse(routes.settings.logs, {
                  settingId:
                    constants.settings.GENERATE_PROPORTIONAL_ON_DOWNGRADE,
                })}
              />
            </Box>
          </TableCell>
        </TableRow>
      </TableBody>
    </Table>
  )
}

export default SettingsInvoiceTable
